import initAboutFlat from './ui/about-flat/about-flat';
import initPlanFlat from './ui/plan-flat/plan-flat';

const initDetailFlat = (parent: HTMLElement): void => {
    if (!parent) {
        console.warn(`Parent is ${parent}`);
    }

    const planFlatEl = parent.querySelector('.detail-flat__plan');

    if (planFlatEl) {
        initPlanFlat(planFlatEl as HTMLElement);
    }

    const aboutFlatEl = parent.querySelector('.detail-flat__about-flat');

    if (aboutFlatEl) {
        initAboutFlat(aboutFlatEl as HTMLElement);
    }
};

export default initDetailFlat;
